/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Seeallcollections2Inputs */

const id_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua koleksi`)
};

const ms_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua koleksi`)
};

const da_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alle samlinger`)
};

const de_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Sammlungen ansehen`)
};

const en_us2_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all collections`)
};

const es_es2_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas las colecciones`)
};

const es_mx2_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas las colecciones`)
};

const fil_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan lahat ng koleksyon`)
};

const fr_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir toutes les collections`)
};

const it_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi tutte le collezioni`)
};

const hu_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes gyűjtemény megtekintése`)
};

const nl_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk alle collecties`)
};

const no_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alle samlinger`)
};

const pl_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wszystkie kolekcje`)
};

const pt_br2_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas as coleções`)
};

const pt_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas as coleções`)
};

const ro_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi toate colecțiile`)
};

const fi_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso kaikki kokoelmat`)
};

const sv_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alla samlingar`)
};

const vi_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem tất cả bộ sưu tập`)
};

const tr_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm koleksiyonları gör`)
};

const cs_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit všechny kolekce`)
};

const bg_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте всички колекции`)
};

const ru_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть все подборки`)
};

const uk_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути всі колекції`)
};

const ar_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض جميع المجموعات`)
};

const hi_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी कलेक्शन देखें`)
};

const th_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูคอลเล็กชันทั้งหมด`)
};

const ja_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのコレクションを見る`)
};

const zh_cn2_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有合集`)
};

const zh_hant1_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視所有合集`)
};

const ko_nav_seeallcollections2 = /** @type {(inputs: Nav_Seeallcollections2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 컬렉션 보기`)
};

/**
* | output |
* | --- |
* | "See all collections" |
*
* @param {Nav_Seeallcollections2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_seeallcollections2 = /** @type {((inputs?: Nav_Seeallcollections2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Seeallcollections2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_seeallcollections2(inputs)
	if (locale === "ms") return ms_nav_seeallcollections2(inputs)
	if (locale === "da") return da_nav_seeallcollections2(inputs)
	if (locale === "de") return de_nav_seeallcollections2(inputs)
	if (locale === "en-US") return en_us2_nav_seeallcollections2(inputs)
	if (locale === "es-ES") return es_es2_nav_seeallcollections2(inputs)
	if (locale === "es-MX") return es_mx2_nav_seeallcollections2(inputs)
	if (locale === "fil") return fil_nav_seeallcollections2(inputs)
	if (locale === "fr") return fr_nav_seeallcollections2(inputs)
	if (locale === "it") return it_nav_seeallcollections2(inputs)
	if (locale === "hu") return hu_nav_seeallcollections2(inputs)
	if (locale === "nl") return nl_nav_seeallcollections2(inputs)
	if (locale === "no") return no_nav_seeallcollections2(inputs)
	if (locale === "pl") return pl_nav_seeallcollections2(inputs)
	if (locale === "pt-BR") return pt_br2_nav_seeallcollections2(inputs)
	if (locale === "pt") return pt_nav_seeallcollections2(inputs)
	if (locale === "ro") return ro_nav_seeallcollections2(inputs)
	if (locale === "fi") return fi_nav_seeallcollections2(inputs)
	if (locale === "sv") return sv_nav_seeallcollections2(inputs)
	if (locale === "vi") return vi_nav_seeallcollections2(inputs)
	if (locale === "tr") return tr_nav_seeallcollections2(inputs)
	if (locale === "cs") return cs_nav_seeallcollections2(inputs)
	if (locale === "bg") return bg_nav_seeallcollections2(inputs)
	if (locale === "ru") return ru_nav_seeallcollections2(inputs)
	if (locale === "uk") return uk_nav_seeallcollections2(inputs)
	if (locale === "ar") return ar_nav_seeallcollections2(inputs)
	if (locale === "hi") return hi_nav_seeallcollections2(inputs)
	if (locale === "th") return th_nav_seeallcollections2(inputs)
	if (locale === "ja") return ja_nav_seeallcollections2(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_seeallcollections2(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_seeallcollections2(inputs)
	return ko_nav_seeallcollections2(inputs)
});
export { nav_seeallcollections2 as "nav.seeAllCollections" }